module.exports = __webpack_public_path__ + "img/PLC-4.befa1235.png";